/* eslint vars-on-top: 0 */

const _directiveDependencies = [];
const _controllerDependencies = ['$scope'];

/**
 * @ngdoc directive
 * @name directives.controller.DisableAccountController
 *
 * @description
 * edit form for user details controller
 */
class DisableAccountController {

    constructor($scope) {

        this.$scope = $scope;
        this.$scope.linkText =
        CWCONFIG.partnerConfig.translationsLinks.mailToDataPrivacy.text;
        this.$scope.href =
        CWCONFIG.partnerConfig.translationsLinks.mailToDataPrivacy.href;
        this.$scope.brandName = CWCONFIG.partnerConfig.name;

    }

}

/**
     * @ngdoc directive
     * @name directives.DisableAccountDirective
     *
     * @description
     * edit form for user details directive
     */
class DisableAccountDirective {

    constructor() {

        this.template = require('./disable-account.html');
        this.restrict = 'EA';
        this.replace = false;
        this.scope = {};

        _controllerDependencies.push($scope =>
            new DisableAccountController($scope));
        this.controller = _controllerDependencies;
        this.controllerAs = 'disableAccountCtrl';

    }

}

_directiveDependencies.push(() => new DisableAccountDirective());


angular.module('directives')
    .directive('disableAccount', _directiveDependencies);




// WEBPACK FOOTER //
// ./scripts/directives/dashboard/my-account/data-settings/disable-account/disable-account.js